import { SvgIcon, SxProps, Theme } from "@mui/material"

export const DeleteIcon = ({ onClick = () => { }, color = "#5C2DB3", sx = {} }: { onClick?: () => void, color?: string, sx?: SxProps<Theme> }) => {
    return (
        <SvgIcon 
            onClick={onClick} 
            viewBox="0 0 7 9"  // Adjust viewBox to tightly fit the icon
            sx={{ 
                width: 14, 
                height: 14,
                ...sx 
            }}
        >
            <path 
                d="M1.4902 8.46464C1.25961 8.46464 1.06221 8.38253 0.897996 8.21832C0.733786 8.05411 0.651681 7.85671 0.651681 7.62612V2.17575H0.232422V1.33723H2.32872V0.917969H4.84427V1.33723H6.94057V2.17575H6.52131V7.62612C6.52131 7.85671 6.43921 8.05411 6.275 8.21832C6.11079 8.38253 5.91338 8.46464 5.68279 8.46464H1.4902ZM5.68279 2.17575H1.4902V7.62612H5.68279V2.17575ZM2.32872 6.7876H3.16724V3.01427H2.32872V6.7876ZM4.00576 6.7876H4.84427V3.01427H4.00576V6.7876Z" 
                fill={color}  // Use the provided color
            />
        </SvgIcon>
    )
}